import { HeaderBar } from "../components/header-bar";
import { FooterBar } from "../components/footer-bar";
import { ContentBox } from "../components/content-box";
import styles from "../app.module.scss";
import { allNews, FrontpageNewsItem } from "../components/news";
import { smallNews, SmallNewsItem } from "../components/small-news";

export const PageHome = () => {
  return (
    <>
      <HeaderBar />
      <ContentBox>
        <h1>Välkommen till Torparängen!</h1>
        {/* <img src={utsikt} alt="Torparängens Utsikt" className={styles.fullW}/> */}

        <div className={styles.row}>
          <div className={styles.colBig}>
            {allNews.map((item: FrontpageNewsItem) => {
              return (
                <>
                  <h2>{item.title}</h2>
                  {item.leftImage && (
                    <img
                      src={item.leftImage}
                      alt={item.leftImageAlt}
                      className={styles.smallLeft}
                    />
                  )}
                  {item.body}
                  <div className={styles.clear} />
                </>
              );
            })}
          </div>

          <div className={styles.colSmall}>
            {smallNews.map((item, index) => (<SmallNewsItem index={index} item={item} />))}
          </div>
        </div>
      </ContentBox>
      <FooterBar />
    </>
  );
};
